<template>
    <div class="quillEditor_pos">
        <div class="quillEditor_wrap" :id="'quillEditor_wrap' + idNum">
        </div>
        <uploads v-show="false" ref="uploadFile" uploadType="img" :accept="['.jpg','.png','.jpeg']" :multiple="true" uploadSize="5mb" @uploadSucess="getUrl" :isCompressFlag="true"></uploads>
    </div>
</template>
<script>
import E from 'wangeditor'
import uploads from '@/components/newUpload/upload.vue'
export default {
    props: {
        value: {
            type: String,
            default: ''
        },
        height: {
            type: Number,
            default: 500
        },
        showFullScreen: {
            type: Boolean,
            default: false
        },
        showLinkImg: {
            type: Boolean,
            default: false
        },
        uploadImgMaxLength: {
            type: Number,
            default: 1
        },
        menuList: {
            type: Array,
            default: () => [
                'head',
                'bold',
                'fontSize',
                // 'fontName',
                'italic',
                'underline',
                'strikeThrough',
                // 'indent',
                'lineHeight',
                // 'foreColor',
                'backColor',
                // 'link',
                // 'list',
                // 'todo',
                'justify',
                'quote',
                // 'emoticon',
                'image',
                'table',
                // 'code',
                // 'splitLine',
                'undo',
                'redo',
            ]
        },
        placeholder: {
            type: String,
            default: '请输入正文'
        }
    },
    data() {
        return {
            isinsertList: [],
            insertImgFn: null,
            idNum: Date.now(),
            isapendFlag: true
        }
    },
    created() {
        this.$nextTick(() => {
            const editor = new E('#quillEditor_wrap' + this.idNum)
            editor.config.height = this.height
            editor.config.menus = this.menuList
            editor.config.showFullScreen = this.showFullScreen
            editor.config.showLinkImg = this.showLinkImg
            editor.config.uploadImgMaxLength = this.uploadImgMaxLength
            editor.config.placeholder = this.placeholder
            editor.create()
            this.$watch(() => this.value, (news) => {
                if(this.isapendFlag && news) {
                    editor.txt.html(news)
                }
            }, {
                immediate: true
            })
            // editor.txt.html('<p>fdssdf</p><p><img src=\"https://video.doutuimao.net/img/2021/12/8BYftzyXFehBTtMs1639721465820.png\"></p><h1>sddDddddddd</h1><p><img src=\"https://video.doutuimao.net/img/2021/12/ciZwfejit3ptnGJG1639721486338.png\"></p><p><br></p><p>fdssdf</p><p><img src=\"https://video.doutuimao.net/img/2021/12/8BYftzyXFehBTtMs1639721465820.png\"></p><h1>sddDddddddd</h1><p><img src=\"https://video.doutuimao.net/img/2021/12/ciZwfejit3ptnGJG1639721486338.png\"></p><p><br></p>') 
            editor.config.onchange = (html) => {
                this.isapendFlag = false
                this.$emit('input', html)
            }
            editor.config.customUploadImg =  (resultFiles, insertImgFn)=>  {
                this.$refs.uploadFile.handleFileList(resultFiles)
                this.insertImgFn = insertImgFn
                
            }
        })
    },
    methods: {
        getUrl(res) {
            console.log(res, '/....res')
            for (let index = 0; index < res.length; index++) {
                if(res[index].url && !this.isinsertList.includes(res[index].key)) {
                    this.isinsertList.push(res[index].key)
                    this.insertImgFn(res[index].url)
                }
            }
            if(this.isinsertList.length == res.length) {
                this.isinsertList = []
            }
        }
    },
    components: {
        uploads
    },
    beforeDestroy() {
        console.log('wewewewewewwee')
    }
}
</script>
<style lang="less">
    .quillEditor_pos {
        position: relative;
        z-index: 100;
    }
    .quillEditor_wrap {
        line-height: normal;
        .w-e-text-container{
            img {
                max-width: 100%!important;
            }
        }
       
    }
</style>